const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const MONTH = 30 * DAY;
const YEAR = 365 * DAY;

const relativeTime = (dateString) => {
  if (!dateString) return "—";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "—";

  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const absDiff = Math.abs(diff);
  const isFuture = diff < 0;

  const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

  if (absDiff < MINUTE) return "just now";
  if (absDiff < HOUR) {
    const mins = Math.round(absDiff / MINUTE);
    return isFuture ? rtf.format(mins, "minute") : rtf.format(-mins, "minute");
  }
  if (absDiff < DAY) {
    const hours = Math.round(absDiff / HOUR);
    return isFuture ? rtf.format(hours, "hour") : rtf.format(-hours, "hour");
  }
  if (absDiff < MONTH) {
    const days = Math.round(absDiff / DAY);
    return isFuture ? rtf.format(days, "day") : rtf.format(-days, "day");
  }
  if (absDiff < YEAR) {
    const months = Math.round(absDiff / MONTH);
    return isFuture ? rtf.format(months, "month") : rtf.format(-months, "month");
  }
  const years = Math.round(absDiff / YEAR);
  return isFuture ? rtf.format(years, "year") : rtf.format(-years, "year");
};

export default relativeTime;
